import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { isEqual } from 'lodash';
import { AppStateService } from '../app/app-state.service';

@Injectable({
  providedIn: 'root'
})
export class CacheLoaderService<T> {
  private cache: T[] = [];
  private baseUrl = environment.landmark_API_URL
  private sampleDataMap = new Map<string, T[]>();

  constructor(private http: HttpClient, private learningModeService: AppStateService) {}

  registerSampleData(url: string, sampleData: T[]): void {
    this.sampleDataMap.set(url, sampleData);
  }

  private loadCacheFromStorage(key: string): T[] {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : [];
}

saveCacheToStorage(key: string, data: T[]): void {
    localStorage.setItem(key, JSON.stringify(data));
}

loadData(url: string, setData: (data: T[]) => void, storageKey: string): void {
  // Check if we're in learning mode and have sample data
  if (this.learningModeService.learningMode() && this.sampleDataMap.has(url)) {
    console.log('Using sample data for:', url);
    const sampleData = this.sampleDataMap.get(url)!;
    setData(sampleData);
    return;
  }
    // console.log('Loading data from cache');
    this.cache = this.loadCacheFromStorage(storageKey);
    if (this.cache.length > 0) {
        // console.log('Data found in cache:', this.cache);
        setData(this.cache);
    } 
    // else {
    //     console.log('No data in cache');
    // }

    this.fetchDataFromBackend(url).subscribe(
        fetchedData => {
            // console.log('Fetched data from backend:', fetchedData);
            if (this.cache.length === 0 || this.hasDataChanged(fetchedData)) {
                // console.log('Data changed or cache was empty, updating cache and signal');
                this.cache = fetchedData;
                this.saveCacheToStorage(storageKey, fetchedData);
                setData(fetchedData);
            } else {
                // console.log('Data not changed, using cached data');
                setData(this.cache);
            }
        },
        error => {
            console.error('Error fetching data from backend:', error);
        }
    );
}

  private fetchDataFromBackend(url: string): Observable<T[]> {
    // console.log('loadData: fetching data from backend:', `${this.baseUrl}/${url}`);
    return this.http.get<T[]>(`${this.baseUrl}/${url}`).pipe(
      tap(data => {
        // Optionally update cache here if needed
        this.cache = data;
      })
    );
  }

  private hasDataChanged(newData: T[]): boolean {
    // console.log('Comparing new data:', newData);
    // console.log('With current cache:', this.cache);
    const dataChanged = !isEqual(newData, this.cache);
    // console.log('Data changed:', dataChanged);
    return dataChanged;
}
}